import { NodeBaseModel, ComparisonNodeBaseModel, BasicComparisonNodeModel, LayersComparisonNodeModel } from '../models';
import { InstanceUtils, ContractComparisonPanels } from '../misc';

interface CreateComparisonNodeParameters {
    nodeId: string;
    nodeName: string;
    newNode?: NodeBaseModel;
    previousNode?: NodeBaseModel;
    layerId?: string;
}

export default class ComparisonNodeFactory {
    static createComparisonNode(parameters: CreateComparisonNodeParameters): ComparisonNodeBaseModel | null {
        const { nodeId, nodeName, newNode, previousNode, layerId } = parameters;

        const isNewNodeBasic = InstanceUtils.isBasicNode(newNode);
        const isPreviousNodeBasic = InstanceUtils.isBasicNode(previousNode);

        if (isNewNodeBasic || isPreviousNodeBasic) {
            return new BasicComparisonNodeModel(
                nodeId,
                nodeName,
                ContractComparisonPanels[nodeId as keyof typeof ContractComparisonPanels],
                isNewNodeBasic ? newNode : undefined,
                isPreviousNodeBasic ? previousNode : undefined
            );
        }

        if (layerId) {
            const isNewNodeLayers = InstanceUtils.isLayersNode(newNode);
            const isPreviousNodeLayers = InstanceUtils.isLayersNode(previousNode);

            return new LayersComparisonNodeModel(
                nodeId,
                nodeName,
                layerId,
                ContractComparisonPanels[nodeId as keyof typeof ContractComparisonPanels],
                isNewNodeLayers ? newNode : undefined,
                isPreviousNodeLayers ? previousNode : undefined
            );
        }

        return null;
    }
}
